import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { createNewSupplement } from '@api/supplements';
import { ICreateNewSupplementResponse, IUserEnteredSupplementData } from '@interfaces/supplements';

export const handleCreateNewSupplement = createAsyncThunk<
  AxiosResponse<ICreateNewSupplementResponse>,
  IUserEnteredSupplementData
>('createNewSupplement', createNewSupplement);
